const convertToNodeTree = (html) => {
  if (typeof html === 'string' && html.length > 0) {
    return new DOMParser().parseFromString(html, 'text/html')
  }
  return null
}

export default convertToNodeTree
